<template>
  <a-spin :spinning="confirmLoading">
    <div class="driver-form-box" :style="{height:height+'px'}">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row class="form-box">
          <a-col :span="24"   v-if="model.id">
            <a-form-item label="挂靠平台">
              <j-search-select-tag
                :disabled="true"
                placeholder="请选择挂靠平台"
                v-decorator="['platformId', validatorRules.platformId]"
                :dictOptions="platformList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24"   v-else>
            <a-form-item label="挂靠平台">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择挂靠平台"
                v-decorator="['platformId', validatorRules.platformId]"
                :dictOptions="platformList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item  label="当前状态">
              <j-dict-select-tag :disabled="disabled" type="list" v-decorator="['currentStatus', validatorRules.currentStatus]" :trigger-change="true" dictCode="current_status" placeholder="请选择当前状态" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item  label="识别号">
              <a-input :disabled="disabled" v-decorator="['identificationNumber', validatorRules.identificationNumber]" placeholder="请输入识别号"  ></a-input>
            </a-form-item>
          </a-col>
<!--
          <a-col :span="24"  v-else>
            <a-form-item  label="识别号">
              <a-input :disabled="true" v-decorator="['identificationNumber', validatorRules.identificationNumber]" placeholder="请输入识别号"  ></a-input>
            </a-form-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-item label="所属车队">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择所属车队"
                v-decorator="['teamId', validatorRules.teamId]"
                :dictOptions="teamList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24"  v-if="checkHasPer('edit:platformNo')">
            <a-form-item  label="所属队长">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择所属队长"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24"  v-else-if="model.id">
            <a-form-item  label="所属队长">
              <j-search-select-tag
                :disabled="true"
                placeholder="请选择所属队长"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24"  v-else>
            <a-form-item  label="所属队长">
              <j-search-select-tag
                :disabled="disabled"
                placeholder="请选择所属队长"
                v-decorator="['leaderId', validatorRules.leaderId]"
                :dictOptions="userList">
              </j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="首次注册时间">
              <j-date :disabled="disabled"   placeholder="请选择首次注册时间" v-decorator="['regTime', validatorRules.regTime]" :trigger-change="true" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
          <a-form-item  label="备注">
          <a-textarea :disabled="disabled"  v-decorator="['remark', validatorRules.remark]"  :rows="5"  placeholder="请输入备注"  ></a-textarea>
          </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
      <view-modal-info ref="driverForm"></view-modal-info>
    </div>
  </a-spin>
</template>

<script>
import {Modal} from "ant-design-vue";
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import { checkHasPer } from "@/utils/authFilter"
  export default {
    name: 'DmPlatformForm',
    components: {
      ViewModalInfo: () => import('../../../dm3.0/driver/DriverInfo')
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        height:document.documentElement.clientHeight-276,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          platformId: {
            rules: [
              { required: true, message: '请选择挂靠平台!'},
            ]
          },currentStatus:{
            rules: [
              { required: true, message: '请如实选择状态!'},
            ]
          }
        },
        url: {
          add: "/dm/dmDriverPlatform/add",
          edit:"/dm/dmDriverPlatform/edit"
        },
        //carList:[],
        platformList:[],
        userList:[],
        teamName:'',
        teamList:[],
        checkHasPer:checkHasPer,
        hasIdNumber:true
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {

      this.getPlatformList();
      this.getUserList();
      this.getTeamList();
    },
    methods: {
      checkHasIdNumber(){
        getAction("/api/driverApi/checkHasIdNumber",{driverId:this.model.driverId}).then(res=>{
          this.hasIdNumber = res.result.hasNumber;
        })
      },
      add (record) {
        this.edit(record);
      },
      edit (record) {
        console.log(record)
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'platformId','driverId','remark','identificationNumber','teamId','leaderId','currentStatus','regTime'))
        });
        this.checkHasIdNumber();
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {

        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            if(this.hasIdNumber){
              this.submitSure(values);
            }else{
              Modal.confirm({
                title: '提示',
                content: '未完善身份证号的信息可能会与其他信息冲突，建议先完善再操作',
                okText: '去完善',
                cancelText: '忽略',
                centered: true,
                onOk: () => {
                  this.$refs.driverForm.showInfo(null, this.model.driverId,{s:'基本信息',leftTab:1,b:'返回挂靠平台详情'})
                },
                onCancel:() =>{
                  this.submitSure(values)
                }
              });
            }
          }

        })

      },submitSure(values){
        const that = this;
        //that.confirmLoading = true;
        let formData = Object.assign(this.model, values);
        if(formData.identificationNumber){
          formData.identificationNumber =  formData.identificationNumber.trim();
        }
        that.$emit('getData',formData);
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'platformId','driverId','remark','identificationNumber','teamId','leaderId','currentStatus','regTime'))
      },
      getPlatformList(){
        var that =this;
        getAction("/dm/dmPlatform/queryAllList",{}).then((res)=>{
          if(res.success){
            let platformList = res.result;
            if(platformList){
              for(var k in platformList){
                that.platformList.push({
                  text:platformList[k].platformName,
                  value:platformList[k].id
                });
              }

            }
          }
        });
      },
      getUserList() {
        var that = this;
        getAction("/sys/user/queryUserList", {}).then((res) => {
          if (res.success) {
            let userList = res.result;
            if (userList) {
              for (var k in userList) {
                that.userList.push({
                  text: userList[k].realname,
                  value: userList[k].id
                });
              }

            }
          }
        });
      },
      getTeamList() {
        var that = this;
        getAction("/dm/dmCarTeam/queryTeamList", {}).then((res) => {
          if (res.success) {
            let teamList = res.result;
            if (teamList) {
              for (var k in teamList) {
                that.teamList.push({
                  text: teamList[k].teamName,
                  value: teamList[k].id
                });
              }

            }
          }
        });
      }
      }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/form.less';

  /deep/ .ant-col-xs-24{
    float: inherit;
  }
  /deep/ .ant-form-item{
    margin-bottom: 0px !important;
  }

  .form-box{
    padding:24px;
  }

  /deep/ .ant-input-disabled.ant-input{
    background: rgb(244, 249, 253) !important;
  }
  /deep/ .ant-select-disabled .ant-select-selection{
    background: rgb(244, 249, 253) !important;
  }
  .driver-form-box{
    overflow-y: scroll;
  }

</style>